<template>
    <v-navigation-drawer mobile-break-point="900px" app clipped width="200px" :mini-variant="mini" permanent dark
                         color="primary">
        <v-divider></v-divider>
        <v-list dense nav class="py-0 mt-3">
            <v-list-item v-for="item in items" :key="item.title" :to="item.link">
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon>
                            <v-icon v-on="on">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                    </template>
                    <span>{{ item.title }}</span>
                </v-tooltip>
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item  v-if="userIsAdmin == 'true'" :key="777" :to="'/activities'">
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon>
                            <v-icon v-on="on">{{ 'mwp-24 fa fa-th-large'}}</v-icon>
                        </v-list-item-icon>
                    </template>
                    <span>{{ 'Activities' }}</span>
                </v-tooltip>
                <v-list-item-content>
                    <v-list-item-title>{{ 'Activities' }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item  v-if="userIsAdmin == 'true'" :key="888" :to="'/users'">
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon>
                            <v-icon v-on="on">{{ 'mwp-24 fa fa-users'}}</v-icon>
                        </v-list-item-icon>
                    </template>
                    <span>{{ 'Users' }}</span>
                </v-tooltip>
                <v-list-item-content>
                    <v-list-item-title>{{ 'Users' }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    export default {
        name: "SideNav",
        data() {
            return {
                 userIsAdmin: localStorage.getItem("userIsAdmin"),
                items: [
                    {title: 'Dashboard', icon: 'mwp-24 fa fa-home', link: '/'},
                    {title: 'Books', icon: 'mwp-24 fa fa-book', link: '/books'},
                    {title: 'Authors', icon: 'mwp-24 fa fa-pen', link: '/authors'},
                ],
                right: null,
            
            }
        }
      
    }
</script>

<style scoped>
    .fa-chevron-left {
        margin-left: 100px;
    }

    .mwp-24 {
        max-width: 24px;
    }
</style>
